import {
  Button,
  makeStyles,
  Snackbar,
} from "@material-ui/core";

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UploadAndDownloadService from "../services/uploadAndDownloadFile";
import { addNewProduct } from "../reduxSaga/actions";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ConfirmAddProduct = ({
  setOnConfirmAddProduct,
  confirmProductModel,
  setMyProductModel,
}) => {
  const dispatch = useDispatch();
 

  const [open, setOpen] = React.useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const handleClose = () => {
    setOpen(false);
    setOnConfirmAddProduct(false);
  };

  const handleConfirm = () => {
    // setOpen(false);
    // setOnConfirmAddProduct(false);

    let productModel = {
      categoryName: confirmProductModel.categoryName,
      description: confirmProductModel.description,

      idBrand: confirmProductModel.idBrand,
      idProductCategory: confirmProductModel.idProductCategory,
      idProductFamily: parseInt(confirmProductModel.idProductFamily),
      idProductSubFamily: confirmProductModel.idProductSubFamily,
      idUserCreation: 0,
      minimumQuantity: confirmProductModel.minimumQuantity.toString(),
      name: confirmProductModel.name,
      productCode: confirmProductModel.productCode,
      sellingPrice: confirmProductModel.sellingPrice.toString(),
      subFamilyName: confirmProductModel.subFamilyName,
      tva: confirmProductModel.tva.toString(),
      imagePath: "any",
    };

    if (confirmProductModel.imageFile != null) {
      const uploadData = new FormData();
      uploadData.append("picture", confirmProductModel.imageFile);

      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadImage/ProductPicture",
        uploadData
      )
        .then((response) => {
          if (Object.keys(response.data)[0] == "success") {
            productModel.imagePath = response.data.success;
            console.log("productModel" + productModel.imagePath);
            setMyProductModel(productModel);

            setOpen(false);
            setOnConfirmAddProduct(false);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });

      // setOpen(false);
      // setOnConfirmAddProduct(false);
    } else {
      dispatch(addNewProduct(productModel));

      setOpen(false);
      setOnConfirmAddProduct(false);
    }
    // if (productModel.idProductCategory == 0) {
    //   console.log("heeeeeee");
    //   productModel.idProductCategory = "null";
    // }
    // if (confirmProductModel.idProductSubFamily == 0) {
    //   productModel.idProductSubFamily = null;
    // }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  // name: name,
  // description: categoryDesc,
  // idProductFamily: familyId,
  // idUserCreation : 0 ,
  // subFamilyName : subFamilyName

  return (
    <>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Confirmer vous l'ajout?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div class="card-body">
              <div class="row" style={{ marginTop: -20 }}>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Libellé: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.name}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Réference: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.productCode}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Stock minimal: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.minimumQuantity}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Prix initial: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.sellingPrice}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Pourcentage tva: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.tva}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom de la marque: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.brandName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom de famille </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.familyName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom de sous famille </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.subFamilyName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom de catégorie: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.categoryName}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Note : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmProductModel.description}{" "}
                  </label>
                </div>

                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Image : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    loading{" "}
                  </label>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginTop: -20 }}>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfirmAddProduct;
